import React from 'react';
import './LoadingSpinner.css';

export const LoadingSpinner = (props) => <div className="popoup-message-spinner-overlay">
    <div id="preloader">
        <div id="loader"></div>
        <i className="fas fa-file-upload spinner-icon"></i>
    </div>
    <h4 className="spinner-text">{props.text}</h4>
</div>
